module.exports = __webpack_public_path__ + "img/Group 9743.e70e80fc.svg";